import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const CUSTOMER_TOKEN_KEY = "ayome_token";
export const ADMIN_TOKEN_KEY = "ayome_admin_token";

export const api = axios.create({ baseURL: API });
const CUSTOMER_USER_KEY = "ayome_user";

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const isTokenExpired = (token) => {
  try {
    const { exp } = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return !exp || exp * 1000 <= Date.now();
  } catch (e) {
    return true;
  }
};

export const expireCustomerSession = () => {
  localStorage.removeItem(CUSTOMER_TOKEN_KEY);
  localStorage.removeItem(CUSTOMER_USER_KEY);
  const next = encodeURIComponent(window.location.pathname);
  window.location.assign(`/login?expired=1&next=${next}`);
};
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(CUSTOMER_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const hadToken = !!error.config?.headers?.Authorization;
    if (error.response?.status === 401 && hadToken && !window.location.pathname.startsWith("/admin")) {
      expireCustomerSession();
    }
    return Promise.reject(error);
  }
);

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
adminApi.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error.config?.url || "";
    if (error.response?.status === 401 && !url.includes("/admin/login")) {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      if (window.location.pathname.startsWith("/admin")) window.location.reload();
    }
    return Promise.reject(error);
  }
);
